import {
  redirectToFxTransactionDetails,
  redirectToScreenMapping,
  redirectToTransactionDetails,
  updateNotifyToReaded,
} from 'components/Profile/func';
import { LogUtil } from 'components/common/LogUtil';
import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import {
  NOTIFICATIONS_PREFIX,
  NOTIFY_TYPE_EVENT,
  NOTIFY_TYPE_FX_TRANSACTION,
  NOTIFY_TYPE_TRANSACTION,
  NOTIFY_TYPE_VOUCHER,
} from 'constants';
import useNotificationStore from 'features/notification/hooks/useNotificationStore';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SET_NEW_NOTIFICATION, SET_SHOW_LOADING } from 'store/action';
import useFormAddTransactionStore from './form-add-transaction/useFormAddTransactionStore';
import useFxFormAddTransactionStore from './fx/useFxFormAddTransactionStore';
import useAuth from './useAuth';
import { useDetectDevice } from './useDetectDevice';
import usePage from './usePage';
import usePortalModal from './usePortalModal';
import useStore from './useStore';

const COUNTDOWN = 30;

const useNotify = (isTriggerIconClick = false) => {
  const { state, dispatch } = useStore();
  const { token } = useAuth();
  const navigate = useNavigate();
  const { isDesktop } = useDetectDevice();
  const { isAddTransactionPage } = usePage();
  const { showPortalModalName } = usePortalModal();
  const { resetSendMoneyFlow, setTransactionDetails: setTransactionDetailsTO } =
    useFormAddTransactionStore();
  const { resetBuyMoneyFlow, setTransactionDetails: setTransactionDetailsFX } =
    useFxFormAddTransactionStore();

  const [countdown, setCountdown] = useState(COUNTDOWN);

  let { isNewNotification, notifications, currentUser } = state;

  const { setCurrentNotifyData } = useNotificationStore();

  useEffect(() => {
    if (!Boolean(notifications?.length)) {
      dispatch({
        type: SET_NEW_NOTIFICATION,
        payload: false,
      });
    }
  }, [notifications]);

  useEffect(() => {
    let timer;

    if (isNewNotification) {
      timer = setTimeout(() => {
        setCountdown((count) => count - 1);
      }, 1 * 1000);
    }

    if (countdown === -1) {
      dispatch({
        type: SET_NEW_NOTIFICATION,
        payload: false,
      });

      setCountdown(COUNTDOWN);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [isNewNotification, countdown]);

  const triggerOnCloseNotificationsNavbarToggleDesktop = () => {
    if (isDesktop) {
      document
        .getElementsByClassName('notification-desktop-icon')?.[0]
        ?.click();
    }
  };
  const triggerOnCloseNotificationsNavbarToggleMobile = () => {
    if (!isDesktop && isTriggerIconClick) {
      document.querySelector('.notification-mobile-icon')?.click();
    }
  };
  const showCancelNavigatingAwayFromFlowModal = (notiData) => {
    triggerOnCloseNotificationsNavbarToggleMobile();
    setCurrentNotifyData(notiData);
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.CANCEL_NAVIGATING_AWAY_FROM_FLOW_MODAL,
    });
  };

  const getNotifyResetTransactionDetailsHandler = () => {
    setTransactionDetailsTO();
    setTransactionDetailsFX();
  };
  const handleSeeAllNotifications = (e, isPass = false) => {
    e?.preventDefault?.();

    if (isAddTransactionPage && !isPass) {
      showCancelNavigatingAwayFromFlowModal();
      return;
    }

    const resetTransactionDetailsHandler =
      getNotifyResetTransactionDetailsHandler;
    resetTransactionDetailsHandler();

    if (isDesktop) {
      triggerOnCloseNotificationsNavbarToggleDesktop();
      navigate(`${NOTIFICATIONS_PREFIX}`);
      return;
    }

    navigate(`${NOTIFICATIONS_PREFIX}?tab=2`);
  };

  const notifyHandlers = {
    [NOTIFY_TYPE_TRANSACTION]: redirectToTransactionDetails,
    [NOTIFY_TYPE_FX_TRANSACTION]: redirectToFxTransactionDetails,
    [NOTIFY_TYPE_EVENT]: redirectToScreenMapping,
    [NOTIFY_TYPE_VOUCHER]: redirectToScreenMapping,
  };
  const markAsRead = (notiData) => {
    if (isEmpty(notiData)) return;
    const { read } = notiData || {};
    if (read) return;
    dispatch({ type: SET_SHOW_LOADING, payload: true });
    updateNotifyToReaded(currentUser, notiData);
  };
  const getNotifyHandler = (type) => notifyHandlers[type] ?? null;
  const getNotifyResetDataFlowHandler = () => {
    resetSendMoneyFlow();
    resetBuyMoneyFlow();
  };
  const handleNotifyOnClick = async (e, notiData, isPass = false) => {
    LogUtil.log('handleNotifyOnClick', 'notiData', notiData);

    e?.preventDefault?.();

    if (isAddTransactionPage && !isPass) {
      showCancelNavigatingAwayFromFlowModal(notiData);
      return;
    }

    if (!isEmpty(notiData)) {
      triggerOnCloseNotificationsNavbarToggleMobile();

      markAsRead(notiData);

      const handler = getNotifyHandler(notiData?.type);
      handler?.(token, notiData, navigate, isDesktop);
    } else {
      handleSeeAllNotifications(e, true);
    }

    const resetDataFlowHandler = getNotifyResetDataFlowHandler();
    const resetDataFlowHandlerTimer = setTimeout(() => {
      resetDataFlowHandler?.();
      clearTimeout(resetDataFlowHandlerTimer);
    }, 1500);

    return;
  };

  return {
    handleNotifyOnClick,
    resetDataFlowHandler: getNotifyResetDataFlowHandler,
    resetTransactionDetailsHandler: getNotifyResetTransactionDetailsHandler,
    handleSeeAllNotifications,
  };
};

export default useNotify;
